import PropTypes from "prop-types";

function ContentContainer({ children, contentGridType, contentPadding, contentBackground, containerPadding }) {
  const gridType = contentGridType ? 'content--' + contentGridType : '';
  const padding = contentPadding ? 'content--padding' : '';
  const background = contentBackground ? 'content--background' : '';
  const contPadding = containerPadding ? 'content-container' : '';

  return (
    <div className={ `wrapper--fluid grid ${ contPadding }` }>
      <div className={ `content ${ gridType } ${ padding } ${ background }` }>
        { children }
      </div>
    </div>
  );
}

ContentContainer.defaultProps = {
  containerPadding: false
}

ContentContainer.propTypes = {
  contentGridType: PropTypes.string,
  contentPadding: PropTypes.bool,
  contentBackground: PropTypes.bool,
  containerPadding: PropTypes.bool
}

export default ContentContainer;
